var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',[_c('h3',[_vm._v("Payment Notifications")])])],1),_c('v-row',[_c('v-col',[_c('IPNTable')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }